import { BubbleMenu as BubbleMenuComment } from '@tiptap/react';
import { jsx as _jsx } from "react/jsx-runtime";

var ControlledBubbleMenuComment = function ControlledBubbleMenuComment(_ref) {
  var editor = _ref.editor,
      className = _ref.className,
      tippyOptions = _ref.tippyOptions,
      children = _ref.children;
  return /*#__PURE__*/_jsx(BubbleMenuComment, {
    editor: editor,
    className: className,
    tippyOptions: tippyOptions,
    shouldShow: function shouldShow(_ref2) {
      var editor = _ref2.editor;
      var selection = editor.state.selection;
      var from = selection.from,
          to = selection.to;
      var selectedText = editor.state.doc.textBetween(from, to, ' ');

      if (!selectedText) {
        return false;
      }

      var shouldShow = true;
      editor.state.doc.nodesBetween(from, to, function (node, pos) {
        var _node$marks, _node$marks2, _node$marks3, _node$marks4, _node$marks5;

        if ((node === null || node === void 0 ? void 0 : (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.length) > 0 && (node !== null && node !== void 0 && (_node$marks2 = node.marks[(node === null || node === void 0 ? void 0 : (_node$marks3 = node.marks) === null || _node$marks3 === void 0 ? void 0 : _node$marks3.length) - 1]) !== null && _node$marks2 !== void 0 && _node$marks2.attrs.commentId || node !== null && node !== void 0 && (_node$marks4 = node.marks[(node === null || node === void 0 ? void 0 : (_node$marks5 = node.marks) === null || _node$marks5 === void 0 ? void 0 : _node$marks5.length) - 1]) !== null && _node$marks4 !== void 0 && _node$marks4.attrs['data-comment-id'])) {
          shouldShow = false;
        }
      });
      return shouldShow;
    },
    children: children
  });
};

export default ControlledBubbleMenuComment;